import { createApp } from "vue";

import "maz-ui/css/main.css";

import "vue-select/dist/vue-select.css";

import App from "./App.vue";
import store from "./store";
import keys from "@/store/keys";
import router from "./router";
import API from "@/store/axios";
// import VueGoogleMaps from "@fawmi/vue-google-maps";

import PinInput from "v-pin-input";
import ArgonDashboard from "./argon-dashboard";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import LoadScript from "vue-plugin-load-script";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { getAnalytics } from "firebase/analytics";
import Toaster from "@meforma/vue-toaster";
import { createVfm } from "vue-final-modal";
const vfm = createVfm();
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { JSEncrypt } from "jsencrypt";
import { Skeletor } from "vue-skeletor";
import ReadMore from "vue-read-more";
import VLazyImage from "v-lazy-image";
import vSelect from "vue-select";
import "./registerServiceWorker";
import VueCleave from "vue-cleave-component";
import Emittery from "emittery";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import authService from "@/services/authService";

const appFirebase = firebase.initializeApp({
  apiKey: "AIzaSyCny6ERYqO-xxU1SW6Nz8b0s3agf4VEN5Y",
  authDomain: "referidos.saludsa.com",
  projectId: "saludsapro",
  storageBucket: "saludsapro.appspot.com",
  messagingSenderId: "203793260657",
  appId: "1:203793260657:web:a4b03a71a0b4e142d53bd0",
  measurementId: "G-4GSMRBJD1N",
});

const analytics = getAnalytics(appFirebase);

const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const encryptBackoffice = new JSEncrypt();
encryptBackoffice.setPublicKey(keys.publicKeyBackoffice);

const decryptBackoffice = new JSEncrypt();
decryptBackoffice.setPublicKey(keys.privateKeyBackoffice);

const ua = navigator.userAgent;

let isMobile = false;

if (
  /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    ua
  )
) {
  //es mobile
  isMobile = true;
} else {
  //es destopk
  isMobile = false;
}

const appInstance = createApp(App);
appInstance.component("MazPhoneNumberInput", MazPhoneNumberInput);
appInstance.component("vue-qrcode", VueQrcode);
appInstance.config.globalProperties.$appFirebase = appFirebase;

appInstance.config.globalProperties.$encryptBackoffice = encryptBackoffice;
appInstance.config.globalProperties.$decryptBackoffice = decryptBackoffice;
appInstance.config.globalProperties.$https = API;
appInstance.config.globalProperties.$isMobile = isMobile;
appInstance.config.globalProperties.$eventBus = new Emittery();
appInstance.config.globalProperties.$authService = authService;
appInstance.use(store);
appInstance.use(router);
appInstance.use(ReadMore);

appInstance.use(VueCleave);
appInstance.use(LoadScript);
// appInstance.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyDAlcyvEoB_DzBgF4JMqr88HZViABFr8nY",
//     libraries: "places",
//   },
// });

appInstance.component("v-select", vSelect);
appInstance.component("v-lazy-image", VLazyImage);
appInstance.component(Skeletor.name, Skeletor);
appInstance.component("VueDatePicker", VueDatePicker);
appInstance.use(VueSweetalert2);
appInstance.use(Toaster);
appInstance.use(vfm);
appInstance.use(PinInput);

appInstance.use(ArgonDashboard);

// Initialize auth service before mounting the app
async function initializeApp() {
  try {
    console.log("[App] Starting app initialization...");

    // Initialize the clean auth service (just App Check)
    console.log("[App] Initializing auth service...");
    await authService.initialize();
    console.log("[App] Auth service initialized successfully");

    // Mount the app
    appInstance.mount("#app");
    console.log("[App] App mounted successfully");

    // Hide the global loading screen
    const loadingElement = document.getElementById("loading-bg");
    if (loadingElement) {
      loadingElement.style.display = "none";
      console.log("[App] Global loading screen hidden");
    }
  } catch (error) {
    console.error("[App] Auth initialization failed:", error);
    // Mount the app anyway, auth will be handled by router
    appInstance.mount("#app");

    // Hide the global loading screen even if initialization failed
    const loadingElement = document.getElementById("loading-bg");
    if (loadingElement) {
      loadingElement.style.display = "none";
      console.log("[App] Global loading screen hidden (after error)");
    }
  }
}

// Start the initialization process
initializeApp();

export { analytics };
